import { render, staticRenderFns } from "./ReplyKeyboardButton.vue?vue&type=template&id=7347558a"
import script from "./ReplyKeyboardButton.vue?vue&type=script&lang=js"
export * from "./ReplyKeyboardButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports